import { SearchPageType, type GAPageTypeName, PDP_GA_NAME } from "../models/SearchPageType";

// TODO Fix this, we cannot base PLP vs SRP using the URL
export function getSearchPageType() {
  const path = window.location.pathname.toLowerCase();

  if (path.includes("selectionassistant")) {
    return SearchPageType.SELECTION_ASSISTANT;
  }
  if (path.includes("searchpage")) {
    return SearchPageType.SEARCH;
  }
  if (path.includes("campaign")) {
    return SearchPageType.Campaign;
  }
  return SearchPageType.PLP;
}

export function isPlpForSeries() {
  const path = window.location.pathname.toLowerCase();
  const parts = path.split("/");

  const plpPos = parts.indexOf("plp");
  if (plpPos === -1) {
    return false;
  }
  // There are two parts in url after "/plp/"
  // series plp pages have the parent category and series in url
  return plpPos + 1 + 2 === parts.length;
}

export function getGALocationForSearchItem(isPdp: boolean | undefined, pageType: SearchPageType): GAPageTypeName {
  if (isPdp) {
    return PDP_GA_NAME;
  } else {
    switch (pageType) {
      case SearchPageType.SEARCH: {
        return "SRP";
      }
      case SearchPageType.PLP: {
        return "PLP";
      }
      case SearchPageType.Campaign: {
        return "CP";
      }
      default:
        return "Unknown";
    }
  }
}
